/* 🤖 this file was generated by svg-to-ts*/
export const icoTickSmall: {
  name: 'tick-small';
  data: string;
} = {
  name: 'tick-small',
  data: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M17 7c-.28 0-.53.11-.71.29L10 13.59l-2.29-2.3a1.003 1.003 0 00-1.42 1.42l3 3c.18.18.43.29.71.29.28 0 .53-.11.71-.29l7-7A1.003 1.003 0 0017 7z" fill="#909090"/></svg>`
};
